module.exports = __webpack_public_path__ + "static/img/func4.5234ca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/func4.png
// module id = hciB
// module chunks = 2